import { useCallback } from 'react';
import { Row, Col } from 'reactstrap';
import { useFormState } from 'utils/hooks';
import { useDispatch } from 'react-redux';

import { FormState } from 'common/entities/form/FormTypes';
import ListSelect from 'common/components/selectors/ListSelect';
import Select from 'common/components/form/inputs/Select';
import { DrawerState } from 'common/entities/drawer/DrawerTypes';

import { getNotLinkedPurchasingStores } from 'store/purchasing-stores/actions';

import GroupField from '../components/GroupField';

const LinkSection = ({ formState, drawer }) => {
  const { fields, selectField } = useFormState(formState);
  const dispatch = useDispatch();

  const onFetchUnlinkedItems = useCallback(
    async search => {
      if (!fields.organization_id?.value || !fields?.store_group?.value?.id) return;

      const filters = [
        { name: 'store_group_id', operation: 'oneOf', value: [fields?.store_group?.value?.id] }
      ];

      try {
        const res = await dispatch(
          getNotLinkedPurchasingStores({
            organization_id: fields.organization_id?.value,
            filters,
            search
          })
        );

        return res?.payload?.data;
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch, fields.organization_id?.value, fields?.store_group?.value?.id]
  );

  return (
    <Row>
      <Col xs={12}>
        <ListSelect
          label="Company"
          list="organizations"
          placeholder="Select company"
          onChange={e => {
            selectField('store_group')(null);
            selectField('equivalent_item')(null);
            selectField('organization_id')(e);
          }}
          {...fields.organization_id}
        />
      </Col>

      <Col xs={12} className="mb-2">
        {drawer?.isOpen ? (
          <GroupField
            label="Item Group"
            key={fields.organization_id?.value}
            placeholder="Select group to filter items"
            endpoint={
              fields.organization_id?.value
                ? `organizations/${fields.organization_id?.value}/purchasing-groups`
                : null
            }
            selectField={selectField}
            onChange={e => {
              selectField('equivalent_item')(null);
              selectField('store_group')(e);
            }}
            disabled={!fields.organization_id?.value}
            storeGroup={fields?.store_group}
          />
        ) : null}
      </Col>

      <Col xs={12} className="mb-1">
        <Select
          isAsync
          invisible={false}
          defaultOptions={onFetchUnlinkedItems}
          loadOptions={onFetchUnlinkedItems}
          onChange={selectField('equivalent_item')}
          getOptionValue={option => option.id}
          disabled={!fields?.store_group?.value?.id}
          getOptionLabel={option => option.description}
          defaultOptionsTriggerChange={
            fields?.store_group?.value?.id || fields.organization_id?.value
          }
          placeholder="Select item"
          label="Equivalent Item"
          {...fields.equivalent_item}
        />
      </Col>
    </Row>
  );
};

export default LinkSection;

LinkSection.propTypes = {
  formState: FormState,
  drawer: DrawerState.isRequired
};
